var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", [_vm._v(_vm._s(_vm.item.value.text))]),
      _vm._v(" "),
      _vm.item.value.description
        ? _c("p", [
            _vm._v("\n        " + _vm._s(_vm.item.value.description) + "\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.item.value.subtext
        ? _c(
            "p",
            { staticClass: "subtext typographies-paragraph-small-regular" },
            [_vm._v("\n        " + _vm._s(_vm.item.value.subtext) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.forceFullList
        ? _c(
            "div",
            { staticClass: "import-buttons" },
            _vm._l(_vm.values.slice(0, _vm.item.valueFrom.maxDisplay), function(
              value
            ) {
              return _c(
                "div",
                {
                  key: _vm.getCopyCode(value),
                  staticClass: "import-buttons__item"
                },
                [
                  _c(
                    "CompassTooltip",
                    {
                      attrs: {
                        content: _vm.localizedTexts.copyValue,
                        placement: "bottom"
                      }
                    },
                    [
                      _c("CompassTagInteractive", {
                        staticClass: "import-buttons__tag",
                        attrs: {
                          variant: "selectable",
                          modelValue: true,
                          valueLabel: value.label
                        },
                        on: {
                          change: function($event) {
                            _vm.handleCopyToClipboardWithToast(
                              _vm.getCopyCode(value)
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.forceFullList || _vm.values.length > _vm.item.valueFrom.maxDisplay
        ? _c("CompassButton", {
            attrs: {
              label: _vm.localizedTexts.showAllValues,
              type: "tertiary",
              size: "small"
            },
            on: {
              click: function($event) {
                return _vm.showModal(_vm.item.valueFrom, _vm.values)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }